import {ISection} from "../../model/B2CInfo";
import './FeaturesItem.css'
import SectionHeader from "../../SectionHeader";
import FeatureCard from "../../features/FeatureCard";
import {IFeature} from "../../features/Feature";
import MobileSectionHeader from "../../MobileSectionHeader";
import MobileFeatureCard from "../../features/MobileFeatureCard";
import React from "react";

interface IFeaturesItemProps {
    section: ISection
    features: Map<string, IFeature>
    mobile: boolean
}

export function FeaturesItem(props: IFeaturesItemProps) {
    if (props.mobile) {
        let features = (props.section.data as Array<string>).map((name) => {
            let feature = props.features.get(name)!;
            return <div className="Features_container_items_mobile__item_container" style={{height: `${(380 * window.innerWidth/375)}px`, width: `${263 * window.innerWidth/375}px`}}>
                <MobileFeatureCard feature={feature} fullScreen={false}/>
            </div>
        });

        return <div className="Features_item_mobile">
            <MobileSectionHeader section={props.section}/>
            <div className="Features_container_items_mobile">
                {features}
            </div>
        </div>
    } else {
        let features = (props.section.data as Array<string>).map((name) => {
            let feature = props.features.get(name)!;
            return <FeatureCard feature={feature}/>;
        });
        return <div className="Section_container">
            <SectionHeader section={props.section}/>
            <div className="Features_container_items">
                {features}
            </div>
        </div>
    }
}